import React from 'react';
import './index.css';

const PageNotFound = () => {
  return <div className="not-found">Page Not Found</div>;
};

export default PageNotFound;
